<div class="container">
  <label nz-checkbox [formControl]="formControl">
    <span class="paragraph-medium regular"><ng-content></ng-content></span>
  </label>
</div>
